import React from 'react';

import ClockThin from 'crehana-icons/ClockThin';

const PromotionMessage = ({
  message,
  className,
}: {
  message: string;
  className?: string;
  messageColor?: string;
}) => (
  <p className={`p-16 ${className}`} style={{ borderRadius: 10 }}>
    <span>
      <ClockThin size={16} ignoreColor className="fill-current text-red-main" />
    </span>
    <span className="ml-8 font-link text-red-main">{message}</span>
  </p>
);

export default PromotionMessage;
